import { Flex, FormControl, FormErrorMessage, FormHelperText, FormLabel } from '@chakra-ui/react';
import type { ComponentStyleConfig } from '@chakra-ui/theme';
import { FC, ReactNode } from 'react';

import { Text } from 'quotient';
import { CommonCIQProps, SelectedStyledSystemProps } from 'quotient/types';

import { fontSizes, textStyles } from '../foundations/typography/typography';

export const FormLabelStyle: ComponentStyleConfig = {
  baseStyle: {
    textStyle: 'bodySemiBold',
    // adding this because font weight was not applying, need to figure out why
    fontWeight: textStyles.bodySemiBold.fontWeight,
    color: 'textHighContrast',
    marginBottom: 0,
  },
};

export const FormStyle: ComponentStyleConfig = {
  baseStyle: {
    requiredIndicator: {
      color: '#FFFFFF00',
    },
    helperText: {
      textStyle: 'bodyRegular',
      color: 'textMediumContrast',
      marginTop: 0,
    },
  },
};

export type FieldProps = {
  children?: React.ReactNode;
  id?: string;
  isRequired?: boolean;
  label: ReactNode;
  description?: string;
  showOptional?: boolean;
  isInvalid?: boolean;
  errorMessage?: string;
} & SelectedStyledSystemProps &
  CommonCIQProps;

export const Field: FC<FieldProps> = ({
  id,
  errorMessage,
  isRequired = false,
  showOptional = false,
  label,
  description,
  isInvalid,
  children,
  ...rest
}) => {
  if (isRequired && showOptional) {
    // Ideally handled via typescript
    throw new Error('Input cannot be required and optional simultaneously');
  }
  return (
    <FormControl
      display="flex"
      flexDirection="column"
      gap={1}
      id={id}
      isInvalid={isInvalid}
      isRequired={isRequired}
      {...rest}
    >
      <Flex flexDirection="row" justifyContent="space-between">
        <FormLabel fontSize={fontSizes.sm}>{label}</FormLabel>
        {showOptional && (
          <Text color="textMediumContrast" m={0} textStyle="bodyRegular">
            Optional
          </Text>
        )}
      </Flex>
      {description && <FormHelperText m={0}>{description}</FormHelperText>}
      {children}
      {isInvalid && errorMessage && (
        <FormErrorMessage color="textDestructive" m={0} textStyle="bodyRegular">
          {errorMessage}
        </FormErrorMessage>
      )}
    </FormControl>
  );
};
